import { c as _c } from "react/compiler-runtime";
import { TopBar } from '@/components/top-bar';
export function NavActions() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 text-sm"><TopBar /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}